var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thing"},[_c('p',[_vm._v("Hello "+_vm._s(_vm.hello)+" from TestComponent.vue!")])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/cpmec.stagingwebsite.dev/web/app/themes/cpmec/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/cpmec.stagingwebsite.dev/web/app/themes/cpmec/node_modules/vue-loader/lib?{}!./scripts/vue/TestComponent.vue?vue&type=template&id=b8e5ca24&scoped=true&
// module id = 103
// module chunks = 0